import { headerFooterService, setInnerHTML, useAsyncEffect, isMobile } from '@sd/shared';
import { memo, useRef } from 'react';

export const Footer = memo(() => {
  const divRef = useRef<HTMLDivElement>(null);
  useAsyncEffect(async () => {
    const html = isMobile()
      ? ''
      : await headerFooterService
          .getFooter()
          // Ignore errors here because we may navigate away from the page before this is done
          .catch(() => '');
    divRef.current && setInnerHTML(divRef.current, html);
  }, [divRef.current]);
  return <div ref={divRef} data-testid="Footer-Container" />;
});
